"use client";
import * as React from "react";
const SvgSavingsFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m14.26 4.84-1.81-1.79a4 4 0 0 1 .25-.9q.1-.22.1-.47A1.2 1.2 0 0 0 11.6.5a4 4 0 0 0-3.2 1.58h-4C1.97 2.08 0 4.02 0 6.42s2 9.08 2 9.08h4.4v-1.58H8v1.58h4.4l1.34-4.41 2.26-.74v-5.5zM8.8 6.03h-4V4.45h4zm2.4 1.58a.8.8 0 1 1 0-1.58c.44 0 .8.35.8.79s-.36.79-.8.79" }));
export {
  SvgSavingsFilled as default
};
